import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { sendRequest } from 'mt-react-common/common/reducers/data/reducer';

import SearchFormRedirect from './SearchFormRedirect';
import PopularItems from './PopularItems';

const faqContentsPopularRN = 'faqContents.objects.faqContentsPopular';

class ContentMain extends Component {
  constructor(props) {
    super(props);
    props.sendRequest();
  }

  render() {
    return (
      <React.Fragment>
        <SearchFormRedirect />
        <PopularItems />
      </React.Fragment>
    );
  }
}

ContentMain.propTypes = {
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  sendRequest: () => dispatch(sendRequest(faqContentsPopularRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentMain);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentMain/ContentMain.js